import React from "react";

import ExecutingStageWithClientsTimeCellContent from "../components/ExecutingStageWithClientsTimeCellContent";

import base from "./base";

import { Column, ColumnId } from ".";

function executingStageWithClientsTime({ width, onResize }: Column.Options) {
	return base(
		ColumnId.ExecutingStageWithClientsTime,
		(item) => <ExecutingStageWithClientsTimeCellContent item={item} />,
		{
			width,

			onResize: onResize as (
				columnWidth?: number | undefined,
				dataKey?: string | undefined,
			) => void,
		},
	);
}

export default executingStageWithClientsTime;
